const envBlackList = /localhost|dev-|qa-/

/**
 * If the url the error is coming from contains an environment that's not our
 * production account, we'll return false so TrackJs doesn't track errors in
 * that environment and add additional noise
 *
 * @param {string} url
 * @returns {bool}
 */
export const removeTrackJsNoise = url => !envBlackList.test(url)
